import {ISchedule} from '../../../Interfaces/Schedule.interfaces';
import {useStyles} from '../../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import SimpleImageLoader from '../../Atoms/SimpleImageLoader';
import _ from 'lodash';
import useGlobalStyles from '../../../styles/globalStyles';
import ImageSelectionAndCropper from "../../Organisms/ImageSelectionAndCropper";
import HidePastEvents from "./HidePastEvents";
import ItineraryVisibility from "./ItineraryVisibility";

const Schedule = (props: ISchedule) => {
    const classes = useStyles();
    const {schedule} = props;
    const {listConfig} = schedule;
    const globalClasses = useGlobalStyles();

    const handleRemove = (type: 'list' | 'details', path: string) => {
        props.removeScheduleImage({type, path});
    };

    const handleChangeStatus = async (name: string, base64: any) => {
        switch (name) {
            case 'list':
                props.saveScheduleListBackground({scheduleListBackground: {3000: base64}});
                break;
            case 'details':
                props.saveScheduleDetailsBackground({scheduleDetailsBackground: {3000: base64}});
                break;
        }
    };

    interface IImageLoader {
        preview: boolean;
        type: 'list' | 'details';
    }

    const ImageLoader = ({preview, type}: IImageLoader) => {
        let imagePath: string | null = '';
        if (preview) {
            imagePath =
                type === 'list' ? schedule.listConfig.backgroundImageURL : schedule.detailsConfig.backgroundImageURL;
        }
        const options = preview
            ? {
                handleRemove: () => handleRemove(type, 'imagePath'),
                removeButton: true,
                confirmationTitle: `Remove ${type} background?`,
            }
            : {};
        return (
            <SimpleImageLoader
                alt={`Itinerary ${type} background`}
                options={options}
                src={preview ? imagePath : ''}
                width={300}
            />
        );
    };
    return (
        <React.Fragment>
            <Grid className={classes.contentWrapper} container spacing={3}>
                <Grid item md={4} xs={12}>
                    <Grid container direction="column" spacing={5}>
                        <Grid data-cy="ListBackground" item xs>
                            <Card className="ListBackgroundCard">
                                <CardHeader classes={{root: globalClasses.cardHeader}} title="List Background"/>
                                <CardContent>
                                    {!_.get(schedule, 'listConfig.backgroundImageURL') && (

                                        <ImageSelectionAndCropper
                                            handleFileSelection={(base64: any) => handleChangeStatus('list', base64)}
                                            aspectRatio={9 / 16}
                                            launchBrowserButtonText={'Add Image'}
                                            recommended={{width: 576, height: 1024}}/>

                                    )}
                                    {_.get(schedule, 'listConfig.backgroundImageURL') && (
                                        <ImageLoader preview={true} type="list"/>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Grid container direction="column" spacing={5}>
                        <Grid data-cy="DetailsBackground" item xs>
                            <Card className="DetailsBackgroundCard">
                                <CardHeader classes={{root: globalClasses.cardHeader}} title="Details Background"/>
                                <CardContent>
                                    {!_.get(schedule, 'detailsConfig.backgroundImageURL') && (

                                        <ImageSelectionAndCropper
                                            handleFileSelection={(base64: any) => handleChangeStatus('details', base64)}
                                            aspectRatio={9 / 16}
                                            launchBrowserButtonText={'Add Image'}
                                            recommended={{width: 576, height: 1024}}/>
                                    )}
                                    {_.get(schedule, 'detailsConfig.backgroundImageURL') && (
                                        <ImageLoader preview={true} type="details"/>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Grid container direction="column" spacing={3}>
                        <Grid item xs={12}>
                            <ItineraryVisibility
                                globalClasses={globalClasses}
                                listConfig={listConfig}
                                toggleHidePastEvents={props.toggleHidePastEvents}
                                schedule={schedule}/>
                        </Grid>
                        <Grid item xs={12}>
                            <HidePastEvents
                                globalClasses={globalClasses}
                                listConfig={listConfig}
                                toggleHidePastEvents={props.toggleHidePastEvents}
                                schedule={schedule}/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default Schedule;
